import { dataGridCellFontFamilyTabularNumsClassName } from '@/assets/themes/components/MuiDataGrid';
import type { LanguageCode } from '@/stores/locale';
import { formatDate } from '@/utils/date';

// Returns a plain inferred object type (no row-generic callbacks) so the spread
// is compatible with GridColDef<TRow> for any TRow without contravariance errors.
export const createDateColumn = (lang: LanguageCode) => ({
  type: 'date' as const,
  align: 'right' as const,
  headerAlign: 'right' as const,
  minWidth: 130,
  flex: 1,
  cellClassName: dataGridCellFontFamilyTabularNumsClassName,
  valueGetter: (value) => new Date(value),
  valueFormatter: (value: Parameters<typeof formatDate>[0]) =>
    formatDate(value, lang),
});
